export const CREATING_MENU = "CREATING_MENU";
export const UPDATING_MENU = "UPDATING_MENU";
export const MENU_CREATED = "MENU_CREATED";
export const MENU_UPDATED = "MENU_UPDATED";
export const ERROR_MENU_CREATE = "ERROR_MENU_CREATE";
export const ERROR_MENU_UPDATE = "ERROR_MENU_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
